module.exports = "../dist/img/img_1-32.7ff0.jpg";